<template>
    <!-- @command: component -->
    <template v-if="type === 'component'">
        <div class="player-container average-container">
            <div class="player-rating-title">
                {{ $t("AVERAGE_RATING") }}
            </div>
            <div class="player-rating-hint-text">
                {{ $t("LAST_10_MATCHES") }}
            </div>
            
            <NoData v-if="avgList('all') === 'all-no-data'" />
            <div class="average-rating-list" v-else>
                <div class="average-rating-text-list">
                    <div
                        v-for="(i, index) in avgList('homeTeam')"
                        class="average-rating-text"
                    >
                        {{ i }}
                    </div>
                    <!-- <template v-if="results?.homeTeam?.avgRatingList.length > 0">
                    </template>
                    <template v-else>
                        <div
                            v-for="(i, index) in 10"
                            class="average-rating-text"
                        >
                            -
                        </div>
                    </template> -->
                </div>
                <div class="average-rating-text-list">
                    <div
                        v-for="(i, index) in avgList('awayTeam')"
                        class="average-rating-text"
                    >
                        {{ i }}
                    </div>
                    <!-- <template v-if="results?.awayTeam?.avgRatingList.length > 0">
                    </template>
                    <template v-else>
                        <div
                            v-for="(i, index) in 10"
                            class="average-rating-text"
                        >
                            -
                        </div>
                    </template> -->
                </div>
            </div>
        </div>
        
        <div class="player-container">
            <div class="player-rating-title">
                {{ $t("PLAYER_RATING") }}
            </div>
            <div class="player-rating-hint-text">
                {{ $t("LAST_MATCH") }}
            </div>
            <div
                class="average-rating-list has-color pa-1rem"
            >
                <div
                    class="average-rating-box rating-home"
                    :class="{
                        'rating-lose':
                            results?.homeTeam?.avgRating <
                            results?.awayTeam?.avgRating,
                    }"
                >
                    {{ results?.homeTeam?.avgRating ? results?.homeTeam?.avgRating : '-' }}
                </div>
                <div class="averate-rating-text">
                    {{ $t("AVERAGE_RATING") }}
                </div>
                <div
                    class="average-rating-box rating-away"
                    :class="{
                        'rating-lose':
                            results?.awayTeam?.avgRating <
                            results?.homeTeam?.avgRating,
                    }"
                >
                    {{ results?.awayTeam?.avgRating ? results?.awayTeam?.avgRating : '-' }}
                </div>
            </div>

            <template v-if="homeTeamFirst || awayTeamFirst">
                <div class="player-rating-list">
                    <div class="player-rating-item" v-if="homeTeamFirst">
                        <div class="player-rating-num">
                            {{ homeTeamFirst.number }}
                        </div>
                        <div class="player-rating-avatar-box">
                            <Icon
                                :category="'player'"
                                :logoUrl="homeTeamFirst.playerUrl"
                                class="avatar"
                            ></Icon>
                            <!-- <img src="@static/images/icons/aspn_icon/player/player_not_found_gray_bg.png" /> -->
                            <Icon
                                :category="'team'"
                                :logoUrl="results?.homeTeam?.teamLogo"
                                class="team"
                            ></Icon>
                        </div>
                        <div class="player-rating-name">
                            {{ homeTeamFirst.name }}
                            <div class="player-rating-position">
                                {{ homeTeamFirst.position }}
                            </div>
                        </div>
                        <div class="player-rating-rate rating-home">
                            {{ homeTeamFirst.rating }}
                        </div>
                    </div>
                    <div class="player-rating-item" v-else>
                        <div class="player-rating-num">
                            #
                        </div>
                        <div class="player-rating-avatar-box">
                            <img src="@static/images/icons/aspn_icon/player/player_not_found_gray_bg.png"
                                class="avatar" />
                                <div class="gray-circle"></div>
                            <!-- <Icon
                                :category="'team'"
                                :logoUrl="results?.homeTeam?.teamLogo"
                                class="team"
                            ></Icon> -->
                        </div>
                        <div class="player-rating-name">
                            {{ $t('NO_PLAYER') }}
                            <div class="player-rating-position">
                                {{ $t('NO_DATA') }}
                            </div>
                        </div>
                        <div class="player-rating-rate rating-home">
                            -
                        </div>
                    </div>

                    <div class="player-rating-item" v-if="awayTeamFirst">
                        <div class="player-rating-num">
                            {{ awayTeamFirst.number }}
                        </div>
                        <div class="player-rating-avatar-box">
                            <Icon
                                :category="'player'"
                                :logoUrl="awayTeamFirst.playerUrl"
                                class="avatar"
                            ></Icon>
                            <Icon
                                :category="'team'"
                                :logoUrl="results?.awayTeam?.teamLogo"
                                class="team"
                            ></Icon>
                        </div>
                        <div class="player-rating-name">
                            {{ awayTeamFirst.name }}
                            <div class="player-rating-position">
                                {{ awayTeamFirst.position }}
                            </div>
                        </div>
                        <div class="player-rating-rate rating-away">
                            {{ awayTeamFirst.rating }}
                        </div>
                    </div>
                    <div class="player-rating-item" v-else>
                        <div class="player-rating-num">
                            #
                        </div>
                        <div class="player-rating-avatar-box">
                            <img src="@static/images/icons/aspn_icon/player/player_not_found_gray_bg.png"
                                class="avatar" />
                                <div class="gray-circle"></div>
                            <!-- <Icon
                                :category="'team'"
                                :logoUrl="results?.homeTeam?.teamLogo"
                                class="team"
                            ></Icon> -->
                        </div>
                        <div class="player-rating-name">
                            {{ $t('NO_PLAYER') }}
                            <div class="player-rating-position">
                                {{ $t('NO_DATA') }}
                            </div>
                        </div>
                        <div class="player-rating-rate rating-away">
                            -
                        </div>
                    </div>
                </div>
                <div
                    class="show-more"
                    @click="seeAll()"
                    v-if="type === 'component'"
                >
                    {{ $t("SEE_ALL") }}
                </div>
            </template>
            <div v-else>
                <NoData />
            </div>
        </div>

        
    </template>
    <!-- @command: mobile > page | web -->
    <template v-else>
        <!-- @command: team tab > mobile -->
        <div class="is-mobile">
            <div class="squad-container">
                <div class="squad-team-list">
                    <div
                        class="squad-team"
                        @click="handleClickTeam(0)"
                        :class="{
                            selected: tabSelectedIndex === 0,
                        }"
                    >
                        {{ $t("ALL") }}
                    </div>
                    <div
                        class="squad-team"
                        v-for="(i, i1) in results"
                        @click="handleClickTeam(i1)"
                        :class="{ selected: tabSelectedIndex === i1 }"
                    >
                        <Icon
                            :logoUrl="
                                i1 === 'homeTeam'
                                    ? matchScoreData?.homeLogo
                                    : matchScoreData?.awayLogo
                            "
                            class="home-match__title-flag"
                        >
                        </Icon>
                        <div class="squad-team-name">

                        {{
                            i1 === "homeTeam"
                                ? matchScoreData?.homeTeamName
                                : matchScoreData?.awayTeamName
                        }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="player-container page">
            <div class="player-rating-title">
                {{ $t("AVERAGE_RATING") }}
            </div>
            <div class="player-rating-hint-text">
                {{ $t("LAST_10_MATCHES") }}
            </div>
            <div v-if="results?.homeTeam?.avgRatingList.length === 0 && results?.awayTeam?.avgRatingList.length === 0">
                <NoData />
            </div>
            <div class="average-rating-list"  v-else>

                <NoData v-if="avgList('all') === 'all-no-data'" />
                <template v-else>
                    <template v-if="!isMobile || isMobile && tabSelectedIndex === 'homeTeam' || tabSelectedIndex === 0">
                        <div class="average-rating-text-list"
                            
                            :class="{ oneteam: tabSelectedIndex === 'homeTeam' }">
                            <div
                                v-for="(i, index) in avgList('homeTeam')"
                                class="average-rating-text"
                                
                            >
                                {{ i }}
                            </div>
                        </div>
                    </template>
                    <template v-if="!isMobile || isMobile && tabSelectedIndex === 'awayTeam' || tabSelectedIndex === 0">
                        <div class="average-rating-text-list"
                            :class="{ oneteam: tabSelectedIndex === 'awayTeam' }">
                        
                            <div
                                v-for="(i, index) in avgList('awayTeam')"
                                class="average-rating-text"
                                
                            >
                                {{ i }}
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>

        <div class="player-container page">
            <div class="player-rating-title">
                {{ $t("PLAYER_RATING") }}
            </div>
            <div class="player-rating-hint-text">
                {{ $t("LAST_MATCH") }}
            </div>

            <NoData
                class="player-rating-list"
                v-if="
                    results?.homeTeam?.players.length === 0 &&
                    results?.awayTeam?.players.length === 0
                "
            />

            <template v-else>
                <div class="player-rating-list" :class="tabSelectedIndex">
                    <div class="player-rating-row" v-if="(tabSelectedIndex === 'homeTeam' || !isMobile)">
                        <!-- @command: rating score -->
                        <div class="average-rating-column rating-home" 
                            v-if="(tabSelectedIndex === 'homeTeam' || !isMobile)">
                            <div
                                class="average-rating-box"
                                :class="{
                                    'rating-lose':
                                        results?.homeTeam?.avgRating <
                                        results?.awayTeam?.avgRating,
                                }"
                            >
                                {{ results?.homeTeam?.avgRating ? results?.homeTeam?.avgRating : '-' }}
                            </div>
                            <div class="average-rating-hints">
                                {{ $t("AVERAGE_RATING_FOR_HOME_TEAM") }}
                            </div>
                        </div>

                        <!-- @command: rating list -->
                        <NoData v-if="results?.homeTeam?.players?.length === 0" />
                        <template v-else-if="results?.homeTeam?.players?.length !== 0">
                            <div
                                class="player-rating-item"
                                v-for="(i, index) in results?.homeTeam?.players"
                            >
                                <div class="player-rating-num">
                                    {{ i.number }}
                                </div>
                                <div class="player-rating-avatar-box">
                                    <Icon
                                        :category="'player'"
                                        :logoUrl="i.playerUrl"
                                        class="avatar"
                                    ></Icon>
                                    <Icon
                                        :category="'team'"
                                        :logoUrl="results.homeTeam.teamLogo"
                                        class="team"
                                    ></Icon>
                                </div>
                                <div class="player-rating-name">
                                    {{ i.name }}
                                    <div class="player-rating-position">
                                        {{ i.position }}
                                    </div>
                                </div>
                                <div
                                    class="player-rating-rate"
                                    :class="{
                                        'rating-home':
                                            i.rating === homeTeamFirst.rating,
                                        'other-rating':
                                            i.rating !== homeTeamFirst.rating,
                                    }"
                                >
                                    {{ i.rating }}
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="player-rating-row" v-if="(tabSelectedIndex === 'awayTeam' || !isMobile)">
                        <!-- @command: rating score -->
                        <div class="average-rating-column rating-away"  v-if="(tabSelectedIndex === 'awayTeam' || !isMobile)">
                            <div
                                class="average-rating-box"
                                :class="{
                                    'rating-lose':
                                        results?.awayTeam?.avgRating <
                                        results?.homeTeam?.avgRating,
                                }"
                            >
                                {{ results?.awayTeam?.avgRating ? results?.awayTeam?.avgRating : '-' }}
                            </div>
                            <div class="average-rating-hints">
                                {{ $t("AVERAGE_RATING_FOR_AWAY_TEAM") }}
                            </div>
                        </div>

                        <!-- @command: rating list -->
                        <template v-if="results?.awayTeam?.players.length !== 0">
                            <div
                                class="player-rating-item"
                                v-for="(i, index) in results?.awayTeam?.players"
                            >
                                <div class="player-rating-num">
                                    {{ i.number }}
                                </div>
                                <div class="player-rating-avatar-box">
                                    <Icon
                                        :category="'player'"
                                        :logoUrl="i.playerUrl"
                                        class="avatar"
                                    ></Icon>
                                    <Icon
                                        :category="'team'"
                                        :logoUrl="results.awayTeam.teamLogo"
                                        class="team"
                                    ></Icon>
                                </div>
                                <div class="player-rating-name">
                                    {{ i.name }}
                                    <div class="player-rating-position">
                                        {{ i.position }}
                                    </div>
                                </div>
                                <div
                                    class="player-rating-rate"
                                    :class="{
                                        'rating-away':
                                            i.rating === awayTeamFirst.rating,
                                        'other-rating':
                                            i.rating !== awayTeamFirst.rating,
                                    }"
                                >
                                    {{ i.rating }}
                                </div>
                            </div>
                        </template>
                        <NoData v-else-if="results?.awayTeam?.players?.length === 0 && results?.homeTeam?.players?.length !== 0" />
                    </div>
                    
                    <template
                        v-if="
                            (results?.homeTeam?.players.length > 0 ||
                                results?.awayTeam?.players.length > 0) &&
                            tabSelectedIndex === 0 &&
                            isMobile
                        "
                    >
                        <div class="average-rating-list has-color">
                            <!-- @command: rating score -->
                            <div class="average-rating-column rating-home">
                                <div
                                    class="average-rating-box"
                                    :class="{
                                        'rating-lose':
                                            results?.homeTeam?.avgRating <
                                            results?.awayTeam?.avgRating,
                                    }"
                                >
                                    {{ results?.homeTeam?.avgRating ? results?.homeTeam?.avgRating : '-' }}
                                </div>
                                <div class="average-rating-hints">
                                    {{ $t("AVERAGE_RATING_FOR_HOME_TEAM") }}
                                </div>
                            </div>

                            <!-- @command: rating score -->
                            <div class="average-rating-column rating-away">
                                <div
                                    class="average-rating-box"
                                    :class="{
                                        'rating-lose':
                                            results?.awayTeam?.avgRating <
                                            results?.homeTeam?.avgRating,
                                    }"
                                >
                                    {{ results?.awayTeam?.avgRating ? results?.awayTeam?.avgRating : '-' }}
                                </div>
                                <div class="average-rating-hints">
                                    {{ $t("AVERAGE_RATING_FOR_AWAY_TEAM") }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="player-rating-item"
                            v-for="(i, index) in allPlayerTeam"
                        >
                            <div class="player-rating-num">
                                {{ i.number }}
                            </div>
                            <div class="player-rating-avatar-box">
                                <Icon
                                    :category="'player'"
                                    :logoUrl="i.playerUrl"
                                    class="avatar"
                                ></Icon>
                                <Icon
                                    :category="'team'"
                                    :logoUrl="
                                        results[
                                            i.team === 'away'
                                                ? 'awayTeam'
                                                : 'homeTeam'
                                        ].teamLogo
                                    "
                                    class="team"
                                ></Icon>
                            </div>
                            <div class="player-rating-name">
                                {{ i.name }}
                                <div class="player-rating-position">
                                    {{ i.position }}
                                </div>
                            </div>
                            <div
                                class="player-rating-rate"
                                :class="{
                                    'rating-away':
                                        i.selected && i.team === 'away',
                                    'rating-home':
                                        i.selected && i.team === 'home',
                                    'other-rating': !i.selected,
                                }"
                            >
                                {{ i.rating }}
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>

        
    </template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "PlayerPeformance",
    data() {
        return {
            isNoData: false,
            results: {},
            mobileResults: {},
            tabSelectedIndex: 0,
            tabs: [],
            matchDetailScore2: {},
        };
    },
    props: {
        type: String,
        matchScoreData: Object,
    },
    computed: {
        ...mapGetters(["isMobile", "currentLocale", "currentSportType"]),
        homeTeamFirst() {
            if (this.results?.homeTeam?.players[0]) {
                return this.results.homeTeam.players[0];
            }
            return null;
        },
        awayTeamFirst() {
            if (this.results?.awayTeam?.players[0]) {
                return this.results.awayTeam.players[0];
            }
            return null;
        },
        matchScoreData() {
            if (this.type === "component") {
                return this.matchDetailScore;
            } else {
                return this.matchDetailScore2;
            }
        },
        allPlayerTeam() {
            if (
                this.results?.homeTeam?.players &&
                this.results?.awayTeam?.players
            ) {
                let home = this.results.homeTeam.players;
                let away = this.results.awayTeam.players;
                if (home[0]) {
                    home[0]["selected"] = true;
                }
                if (away[0]) {
                    away[0]["selected"] = true;
                }
                home.forEach((x) => {
                    x["team"] = "home";
                });
                away.forEach((x) => {
                    x["team"] = "away";
                });

                const combined = [...home, ...away];
                combined.sort((a, b) => b.rating - a.rating);
                return combined;
            }
        },
    },
    mounted() {
        this.getPerformanceRating();
        if (!this.matchDetailScore) {
            this.getMatchDetailScoreDataAsync();
        }
    },
    methods: {
        ...mapActions([
            "getPerformance",
            "getMatchDetailScoreWinRate",
            "getMatchDetailScoreAsync",
            "getMatchDetailScoreLatestEuropeOdds",
        ]),
        avgList(team) {
            let result = this.results
            // @command: confirm hava data
            if(result && result[team] && result[team].avgRatingList &&
                result && result[team === 'homeTeam' ? 'homeTeam' : 'awayTeam'] && result[team === 'homeTeam' ? 'homeTeam' : 'awayTeam'].avgRatingList
            ) {
                // @command: check all got data 
                if(team === 'all') {
                    if(self.length === 0 && other.length === 0 ) {
                        return 'all-no-data'
                    } 
                }
                let self = result[team].avgRatingList
                let other = result[team === 'homeTeam' ? 'awayTeam' : 'homeTeam'].avgRatingList
                // @command: self no data but other have
                if(self.length === 0 && other.length !== 0) {
                    let count = 0
                    while(count < 10) {
                        self.push('-')
                        count++
                    }
                } 
                // @command: other no but self have 
                // else if(other.length === 0 && self.length !== 0)  {
                //     let count = 0
                //     while(count < 10) {
                //         other.push('-')
                //         count++
                //     }
                // }
                // @command: if less than 10 data will fill to 10
                else if(self.length < 10) {
                    let max = 10
                    let remainAdd = max - self.length
                    let count = 0
                    while(count < remainAdd) {
                        self.push('-')
                        count++
                    }
                }
                return self
            }
            return []
        },
        async getPerformanceRating() {
            // this.isLoading = true;
            // if (this.manualRefreshMatchDetail) {
            //     this.isSkeletonLoading.performanceRating = true;
            // }
            const result = await this.getPerformance({
                matchId: this.$route.params.matchId,
            });

            // this.isLoading = false;

            this.dataValidation(result.result);
        },
        dataValidation(data) {
            if (!data.homeTeam && !data.awayTeam) {
                this.isNoData = true;
            } else {
                this.isNoData = false;
                this.results = data;
                this.mobileResults = this.results[this.teamSelected];
            }
        },
        seeAll() {
            let params = this.$route.params;
            if (this.type === "component") {
                this.$router.push(
                    `/${this.currentLocale}/${this.currentSportType}/${params.country}/${params.club}/${params.opponent}/${params.matchId}/analysis-details/player-peformance`
                );
            }
        },
        async getMatchDetailScoreDataAsync() {
            let params = {
                matchId: this.$route.params.matchId,
                timeZone: this.$tools.getCurrentTimeZone(),
            };

            const resultWinRate = await this.getMatchDetailScoreWinRate(params);
            const result = await this.getMatchDetailScoreAsync(params);
            const resultOdd = await this.getMatchDetailScoreLatestEuropeOdds(
                params
            );

            this.matchDetailScore2 = result.result;
            // this.matchDetailWinRate =
            //     resultWinRate.result == null ? {} : resultWinRate.result;

            // this.matchDetailOdds = resultOdd.result;
            // if (resultOdd.result === null) {
            //     this.matchDetailOdds = {};
            //     this.matchDetailOdds.awayOdds = "-";
            //     this.matchDetailOdds.drawOdds = "-";
            //     this.matchDetailOdds.homeOdds = "-";
            // }

            // this.matchDetailScore.matchState = 1;
            // this.matchDetailScore.containLiveStream = true;
            // this.updateLiveStreamTrackerScoreFavUI(this.matchDetailScore);

            // this.isHasLive(this.matchDetailScore.containLiveStream);

            // this.intiHighlightDetailLink();
            // if (!this.manualRefreshMatchDetailScore) {
            // this.initLiveVideo();
            // }
        },
        handleClickTeam(o) {
            this.tabSelectedIndex = o;
        },
    },
};
</script>

<style scoped>
.player-container {
    padding: 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
}
/* for test */
.player-rating-title {
    font-size: 24px;
    font-family: var(--weight-600);
    letter-spacing: -0.48px;
    margin-bottom: 4px;
    text-align: center;
    color: var(--color-text-default-default);
}
.player-rating-hint-text {
    font-size: 16px;
    color: var(--color-text-default-secondary);
    text-align: center;
    margin-bottom: 16px;
    text-align: center;
}
.show-more {
    width: 100%;
    text-align: center;
    padding: 8px;
    box-sizing: border-box;
    font-size: 16px;
    color: var(--color-text-default-default);
    letter-spacing: 0.64px;
}
.average-rating-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.player-container.page {
    margin: 16px 8px;
    padding-top: 32px;
    border-top: 1px dashed var(--color-border-default-default);
}
.player-container.page:last-child {
    margin-bottom: 64px;
}
.player-container.page .average-rating-list {
    gap: 128px;
}
.average-rating-list.header {
    justify-content: space-evenly;
    gap: 167px !important;
}
.average-rating-box {
    /* width: 64px; */
    /* height: 40px; */
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-default-netural);
    border-radius: 8px;
    font-size: 48px;
    font-family: var(--weight-700);
    margin-top: 8px;
}
.average-rating-column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    margin: 8px auto 16px;
    padding-bottom: 8px;
    border-radius: 4px;
}
.average-rating-hints {
    text-align: center;
    color: var(--color-text-default-netural);
}
.rating-home {
    background: var(--primary-400);
}
.averate-rating-text {
    width: 150px;
    font-size: 16px;
    font-family: var(--weight-600);
    text-align: center;
    color: var(--color-text-default-default);
}
.rating-away {
    background: var(--secondary-400);
}
.rating-lose {
    opacity: 0.4;
}
.player-rating-list {
    display: flex;
    align-items: stretch;
    gap: 16px;
}
.player-rating-row {
    flex: 1;
    padding: 16px;
    border: 1px solid var(--color-border-default-default);
    border-radius: 8px;
}
.player-rating-item {
    padding: 12px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}
.player-rating-num {
    font-size: 13px;
    font-family: var(--weight-600);
    width: 20px;
    flex-shrink: 0;
    text-align: center;
    color: var(--color-text-default-default);
}
.player-rating-avatar-box {
    display: flex;
    align-items: center;
    gap: 1.8px;
}
.player-rating-avatar-box .avatar {
    width: 36px;
    height: 36px;
    object-fit: contain;
    padding: 1.6px;
    background-color: var(--color-background-default-default-hover);
    border-radius: 50%;
}
.player-rating-avatar-box .team {
    width: 16px;
    height: 16px;
    object-fit: contain;
    padding: 1.6px;
    background-color: var(--color-background-default-default-hover);
    border-radius: 50%;
}
.player-rating-name {
    font-size: 16px;
    font-family: var(--weight-600);
    width: 100%;
    color: var(--color-text-default-default);
}
.player-rating-position {
    color: var(--color-text-default-secondary);
    font-size: 14px;
    font-family: var(--weight-400);
}
.player-rating-rate {
    width: 39px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 8px;
    font-size: 16px;
    font-family: var(--weight-600);
    color: var(--color-text-default-netural);
    display: flex;
    align-items: center;
    justify-content: center;
}

.squad-container {
    padding: 16px 16px 0;
    box-sizing: border-box;
    background-color: var(--color-background-default-secondary);
    margin-bottom: 16px;
}
.squad-team-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    background-color: var(--color-background-default-secondary);
}
.squad-team {
    display: flex;
    align-items: center;
    font-family: var(--weight-600);
    font-size: 14px;
    gap: 8px;
    padding: 0px 8px 8px;
    /* margin: 0 8px; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--color-text-default-tertiary);
}
.squad-team.selected {
    position: relative;
    color: var(--color-text-default-default);
}
.squad-team.selected:after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: var(--primary-500);
    content: "";
    display: block;
}
.average-rating-text-list {
    display: grid;
    grid-template-columns: repeat(5, auto);
    gap: 23px;
}
.average-rating-text {
    width: 33px;
    font-family: var(--weight-600);
    font-size: 16px;
    text-align: center;
    color: var(--color-text-default-default);
}
.other-rating {
    color: var(--color-text-default-default);
}
.gray-circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--color-background-default-default-hover);
}

@media(max-width: 768px) {
    .average-rating-text-list {
        display: grid;
        grid-template-columns: repeat(2, auto);
        gap: 23px;
        row-gap: 8px;
    }
    .average-container .average-rating-list {
        gap: 78px;
    }
    .player-container.page {
        border-top: 0;
        padding-top: 16px;
    }
    .player-rating-list {
        display: block;
    }
    .player-rating-list.homeTeam .player-rating-row,
    .player-rating-list.awayTeam .player-rating-row {
        padding-top: 0;
    }
    .player-rating-row {
        border: 0;
        padding-left: 0;
        padding-right: 0;
    }
    .average-rating-column {
        margin-top: 0;
        border-radius: 8px;
        padding: 16px 8px 16px;
        /* padding-top: 0; */
    }
    .average-rating-box {
        font-size: 20px;
        width: 64px;
        height: 40px;
        margin-top: 0;
    }
    .average-rating-column .average-rating-box {
        font-size: 48px;
        font-family: var(--weight-700);
    }
    .player-container.page .average-rating-list {
        gap:  56px;
    }
    .player-container.page .average-rating-list.has-color {
        gap:  16px;
    }
    .player-container.page .average-rating-text-list.oneteam {
        grid-template-columns: repeat(5, auto);
    }
    .squad-team-name {
        max-width: 140px;
        white-space: nowrap; /* 文本不换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */

    }
}
</style>
